const logo = "/napihami_logo.png";

export function LoadingSpinner() {
  return (
    <div className="flex items-center justify-center animate-fade-in">
      <img 
        src={logo} 
        alt="NapiHami" 
        className="h-16 w-auto animate-pulse"
        width="168"
        height="64"
      />
    </div>
  );
}
